import services from '@/config/services'
import FileManager from '@/services/ask-file-manager/index.js'

export default class VolturaService {
  constructor(http, eventBus){
    this.http = http
    this.eventBus = eventBus
    this.praticheUrl = `${services.ask_pratiche.url}`
    this.apiUrl = `${services.ask_api.url}/management`
    this.filemanager = new FileManager()
  }
 
  async getClients() {
    let items = []
    let success = false
    const url = `${this.praticheUrl}/get-clients`

    try {
      let res = await this.http.get(url)
      items = res.data
      success = true
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }

    return { items, success }
  }

  async getSpedizioni() {
    let items = []
    let success = false
    const url = `${this.praticheUrl}/get-spedizioni`

    try {
      let res = await this.http.get(url)
      items = res.data
      success = true
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }

    return { items, success }
  }

  async getPagamenti() {
    let items = []
    let success = false
    const url = `${this.praticheUrl}/get-pagamenti`

    try {
      let res = await this.http.get(url)
      items = res.data
      success = true
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }

    return { items, success }
  }

  async getIvas() {
    let items = []
    let success = false
    const url = `${this.praticheUrl}/get-ivas`

    try {
      let res = await this.http.get(url)
      items = res.data
      success = true
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }

    return { items, success }
  }

  async getScadenze() {
    let items = []
    let success = false
    const url = `${this.praticheUrl}/get-scadenze`

    try {
      let res = await this.http.get(url)
      items = res.data
      success = true
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }

    return { items, success }
  }

  async getOfferte() {
    let items = []
    let success = false
    const url = `${this.praticheUrl}/get-offerte`

    try {
      let res = await this.http.get(url)
      items = res.data
      success = true
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }

    return { items, success }
  }


  async getFatturazioni() {
    let items = []
    let success = false
    const url = `${this.praticheUrl}/get-fatturazioni`

    try {
      let res = await this.http.get(url)
      items = res.data
      success = true
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }

    return { items, success }
  }


  async getPeriodi() {
    let items = []
    let success = false
    const url = `${this.praticheUrl}/get-periodi`

    try {
      let res = await this.http.get(url)
      items = res.data
      success = true
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }

    return { items, success }
  }


  async getAcquisizioni() {
    let items = []
    let success = false
    const url = `${this.praticheUrl}/get-acquisizioni`

    try {
      let res = await this.http.get(url)
      items = res.data
      success = true
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }

    return { items, success }
  }

  async getStati() {
    let items = []
    let success = false
    const url = `${this.praticheUrl}/get-stati`

    try {
      let res = await this.http.get(url)
      items = res.data
      success = true
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }

    return { items, success }
  }

  async getAgenti() {
    let items = []
    let success = false
    const url = `${this.praticheUrl}/get-agenti`

    try {
      let res = await this.http.get(url)
      items = res.data
      success = true
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }

    return { items, success }
  }

  async getTipiCtr() {
    let items = []
    let success = false
    const url = `${this.praticheUrl}/get-tipi-ctr`

    try {
      let res = await this.http.get(url)
      items = res.data
      success = true
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }

    return { items, success }
  }

  

  async submitVolturaContratto(payload) {
    const url = `${this.apiUrl}/AreaFlussi/caricamento-flows/importVolturaContratto`
    let success = false
    try {
      let res = await this.http.post(url, payload)
      success = res.data.success
    } catch (err) {
      this.eventBus.emit('data-submit-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-submitted')
    }

    return { success }
  }


  async sendClientData(clientData) {
    const url = `${this.apiUrl}/AreaFlussi/caricamento-flows/getClientData`;
  
    try {
      const response = await this.http.post(url, clientData);
      return response.data;
    } catch (err) {
      this.eventBus.emit('data-submit-error', { message: err, url });
      throw err;
    }
  }

}
